<template>
  <div v-if="dialogVisible" id="lv-feedback" class="feedback-dialog-wrap">
    <div class="feedback-dialog">
      <div class="feedback-left-left">
        <template v-if="curRadishDetail">
          <div class="feedback-left-left-head">
            <span class="radish-info-name" style="width:auto" @click="showRadish({rid:curRadishDetail.rid})">{{curRadishDetail.姓名}}{{age?`(${age})`:''}}</span>
            <span class="radish-info-name" style="cursor:auto">长意：{{curRadishDetail.长期意向}}</span>
          </div>
          <div class="feedback-left-left-content">
            <el-button v-if="cvId" size="small" type="primary" plain @click="preview(cvId)">查看简历</el-button>
          </div>
          <div class="feedback-left-left-content"><b>目前公司：</b>{{curRadishDetail.公司}}</div>
          <div class="feedback-left-left-content"><b>目前职位：</b>{{curRadishDetail.目前职位}}</div>
          <div class="feedback-left-left-title">工作经历：</div>
          <div v-for="(item,idx) in curRadishDetail.任职经历" :key="idx">
            <div class="feedback-left-left-content">{{item.公司}}({{item.起始时间}}-{{item.结束时间}})</div>
            <div class="feedback-left-left-content"><b>职位：</b>{{item.目前职位}}</div>
          </div>
          <template v-if="curRadishDetail.硕士院校||curRadishDetail.本科院校">
            <div class="feedback-left-left-title">教育背景：</div>
            <div v-if="curRadishDetail.硕士院校" class="feedback-left-left-content"><b>硕士：</b>{{curRadishDetail.硕士院校}}</div>
            <div v-if="curRadishDetail.本科院校" class="feedback-left-left-content"><b>本科：</b>{{curRadishDetail.本科院校}}</div>
          </template>
          <div class="feedback-left-left-title">简介：</div>
          <div class="feedback-left-left-detail">{{curRadishDetail.简介}}</div>
        </template>
        <template v-else>
          <div class="feedback-left-left-empty">
            <i class="el-icon-chat-line-round"></i>
            <span>请选择人选</span>
          </div>
        </template>
      </div>
      <div class="feedback-left">
        <div>
          <div class="left-header">
            <div class="pro-title" style="justify-content: space-between"><span>{{project?project.项目名称:'未填写'}}</span><span>{{project&&project.客户公司}}</span></div>
          </div>
          <div class="left-content">
            <div v-for="(item,idx) in curRadishes" :key="idx" :class="'radish-item '+(curRadish&&item._id===curRadish._id?'radish-item-active':'')" @click="chooseRadish(item)">
              <div class="radish-info">
                <div class="radish-info-name" style="color:#333;cursor:auto">{{item.姓名}}</div>
              </div>
              <div class="radish-info-client">{{item.最新操作时间?dateformat(item.最新操作时间):'--'}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="feedback-right">
        <div class="feedback-close" @click="closeDialog"><i class="el-icon-close"></i></div>
        <div class="right-header">
          <div class="detail-info">
            <div style="width:25%;display: flex;align-items: center;">
              <div class="radish-info-name" @click="showRadish(curRadish)">{{curRadish?curRadish.姓名:'请选择人选'}} </div>
            </div>
          </div>
        </div>
        <div ref="feedContent" class="right-content">
          <template v-if="curRadish">
            <div v-for="(item,idx) in progressLogs" :key="idx" :class="'feedback-item '+('radish'===item.identity?'feed-left':'feed-right')">
              <div class="feedback-info">
                <div class="feedback-clientname">{{ 'radish' === item.identity ? curRadish.姓名 : item.hunterId }}</div>
                <div class="feedback-time">{{dateformat(item.time)}}</div>
                <!-- <el-tag size="mini" type="primary" style="margin-right:10px">{{item.type}}</el-tag> -->
              </div>
              <div class="feedback-content">{{item.content}}</div>
            </div>
          </template>
        </div>
        <div class="right-footer">
          <div class="refresh-btn" @click="getLogs(curRadish)"><i class="el-icon-refresh-right"></i></div>
          <div class="bottom-input">
            <el-input v-model="feedback" style="width:100%" type="textarea" placeholder="给候选人反馈" :rows="3" resize="none"></el-input>
            <el-button type="primary" size="small" style="position:absolute;right:20px;bottom:20px" @click="singleSave()">
              保存</el-button>
          </div>
        </div>
      </div>
      <div class="feedback-right-right">
        <h3>快捷操作</h3>
        <div class="quick-title">
          <div class="line"></div><span>改变在线状态</span>
          <div class="line"></div>
        </div>
        <div class="quick-btn-box">
          <div v-for="item in articles" :key="item.url" class="quick-btn" @click="changeOnlineStatus(curRadish)">
            目前状态：{{ onlineStatus }}
          </div>
        </div>
        <div class="quick-title">
          <div class="line"></div><span>微信文章</span>
          <div class="line"></div>
        </div>
        <div class="quick-btn-box">
          <div v-for="item in articles" :key="item.url" class="quick-btn" @click="sendArticle(item)">
            {{ item.title }}
          </div>
        </div>
        <div class="quick-title">
          <div class="line"></div><span>快捷话术</span>
          <div class="line"></div>
        </div>
        <div class="quick-btn-box">
          <div v-for="item in sentences" :key="item" class="quick-btn" @click="sendSentence(item)">
            {{ item }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { get } from 'fingerprintjs2'

const dateFormat = require('dateformat')

let checkOnlineStatus = null
export default {
  props: {
    project: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      account: app.user.account,
      // account: 'qinchao',
      pid: '',
      cvId: '',
      curRids: [],
      curRadishes: [],
      hrInfo: null,
      curRadish: null,
      curRadishDetail: null,
      progressLogs: [],
      dialogVisible: false,
      onlineStatus: '在线',
      feedback: '',
      articles: [{ title: '“圆手”使用指南', url: 'https://mp.weixin.qq.com/s/j7pPxzTguNXNmP1S9TCI4g' }],
      sentences: [
        '转换的过程中，您比较在意什么呢',
        '您对他们公司熟悉吗？之前有接触过吗？',
        '您更偏好什么类型的公司？',
        '您怎么看这个市场？',
      ],
    }
  },
  computed: {
    age() {
      if (this.curRadishDetail && this.curRadishDetail.出生年月) {
        const birth = this.curRadishDetail.出生年月
        const birthInt = parseInt(birth)
        if (!isNaN(birthInt) && birthInt > 999) {
          return new Date().getFullYear() - birthInt
        }
      }
      return null
    },
  },
  methods: {
    async open(arr,curRad) {
      this.curRadishes = arr
      this.chooseRadish(curRad || arr[0])
      this.dialogVisible = true
      // setTimeout(() => {
      //   this.$refs.feedContent.scrollTo(0, this.$refs.feedContent.scrollHeight)
      //   if (document.getElementsByClassName('radish-item-active')[0]) {
      //     document.getElementsByClassName('radish-item-active')[0].scrollIntoView()
      //   }
      // }, 200)
    },
    scroll2bottom(){
      this.$nextTick(() => {
        this.$refs.feedContent.scrollTop = this.$refs.feedContent.scrollHeight;
      })
    },
    sendArticle(item) {
      this.feedback = `您已向对方发送了【${item.title}】`
      this.singleSave(item)
    },
    sendSentence(item) {
      this.feedback = item
      // this.singleSave()
    },
    dateformat(time) {
      return dateFormat(time, 'yyyy.mm.dd HH:MM')
    },
    async getOnlineStatus(radish) {
      const pid = this.pid || this.project._id
      const account = app.user.account
      const tel = radish.lvObj.phoneNumber
      const url = `https://nenglijihe.hewa.cn/api/deliver/getHunterOnlineStatus?coreProjectId=${pid}&phoneNumber=${tel}&hunterId=${account}&identity=hunter`
      // eslint-disable-next-line no-await-in-loop
      const res = await window.app.service('misc').urlGet({ url })
      if (res.status === 'success') {
        this.onlineStatus = res.data
      } else this.$message.error(res.msg)
    },
    async changeOnlineStatus(radish, status) {
      const pid = this.pid || this.project._id
      const account = app.user.account
      const tel = radish.lvObj.phoneNumber
      let onlineStatus = ''
      if (status) {
        onlineStatus = status
      } else {
        onlineStatus = this.onlineStatus === '在线' ? '离线' : '在线'
      }
      const url = `https://nenglijihe.hewa.cn/api/deliver/changeHunterOnlineStatus?coreProjectId=${pid}&phoneNumber=${tel}&hunterId=${account}&onlineStatus=${onlineStatus}`
      // eslint-disable-next-line no-await-in-loop
      const res = await app.service('wechat').externalApi({
        baseUrl: 'https://nenglijihe.hewa.cn',
        path: `/api/deliver/changeHunterOnlineStatus?coreProjectId=${pid}&phoneNumber=${tel}&hunterId=${account}&onlineStatus=${encodeURI(
          onlineStatus,
        )}`,
        method: 'GET',
      })
      // const res = await window.app.service('misc').urlGet({ url })
      if (res.status === 'success') {
        this.onlineStatus = res.data
      } else this.$message.error(res.msg)
    },
    async singleSave(article = null) {
      if (!this.feedback) return
      const form = {
        phoneNumber: this.curRadish.lvObj && this.curRadish.lvObj.phoneNumber,
        hunterId: this.account,
        // "coreProjectId":"r1YcS_E5O",
        coreProjectId: this.project._id,
        content: this.feedback,
        identity: 'hunter',
      }
      if (article) {
        form.type = 'wxArticle'
        form.src = article.url
      }
      const res = await app.service('wechat').externalApi({
        baseUrl: 'https://nenglijihe.hewa.cn',
        path: '/api/deliver/addCommunication',
        method: 'POST',
        externalData: form,
      })
      if (res.status === 'success') {
        this.getLogs(this.curRadish)
        this.feedback = ''
      }
    },
    async getLogs(radish) {
      const pid = this.pid || this.project._id
      const account = app.user.account
      const tel = radish.lvObj.phoneNumber
      const url = `https://nenglijihe.hewa.cn/api/deliver/getCommunication?coreProjectId=${pid}&phoneNumber=${tel}&hunterId=${account}&identity=hunter`
      // eslint-disable-next-line no-await-in-loop
      const res = await window.app.service('misc').urlGet({ url })
      if (res.status === 'success') {
        const logs = Array.isArray(res.data) ? res.data : []
        logs.sort((a, b) => b.time - a.time)
        this.$set(radish, 'progressLogs', logs)
        const progressLogs = window._.cloneDeep(this.curRadish.progressLogs || [])
        progressLogs.sort((a, b) => a.time - b.time)
        this.progressLogs = progressLogs
        this.$set(radish.lvObj, 'hunterUnreadNum', 0)
        this.$emit('computedLvBadge')
        this.$set(radish, '最新操作时间', logs[0] && logs[0].time)
        this.scroll2bottom()
      } else this.$message.error(res.msg)
      await this.changeOnlineStatus(this.curRadish, '在线')
      clearTimeout(checkOnlineStatus)
      checkOnlineStatus = setTimeout(async () => {
        await this.changeOnlineStatus(this.curRadish, '离线')
      }, 1000 * 60 * 5) // 5分钟不操作后切换为离线状态
    },
    showRadish(row) {
      if (!row.rid || row.状态 === '失效') return
      window.open(`${window.frontend}/#/radish-detail-blank/${row.rid}`, '_blank')
    },
    chooseRadish(item) {
      this.curRadish = item
      this.getLogs(this.curRadish)
      this.getAttachment(this.curRadish.rid)
      this.curRadishDetail = this.curRadish
    },
    closeDialog() {
      this.dialogVisible = false
      this.changeOnlineStatus(this.curRadish, '离线')
      clearTimeout(checkOnlineStatus)
    },
    async getAttachment(rid) {
      const { data } = await app.service('radish').listAttachment({ rid })
      // const report = data.filter(d => d.type === '推荐报告').sort((a, b) => b.createdAt - a.createdAt)[0]
      // if (report) {
      //   this.reportId = report.md5
      // } else {
      //   this.reportId = ''
      // }
      const cv = data.filter(d => d.type === 'cv' || d.type === '原始简历').sort((a, b) => b.createdAt - a.createdAt)[0]
      if (cv) {
        this.cvId = cv.md5
      } else {
        this.cvId = ''
      }
    },
    async preview(md5) {
      const ref = app.root.$refs.cvPreview
      if (!ref) return
      ref.getFile({ md5 })
      ref.show()
    },
  },
}
</script>
<style>
#lv-feedback .el-button--primary.is-plain {
  background-color: #fff;
  border-color: #2478b5;
  color: #4394b9;
}
</style>
<style scoped>
* {
  box-sizing: border-box;
}
.feedback-dialog {
  width: 90%;
  height: 80vh;
  background-color: #fff;
  display: flex;
  z-index: 90;
  position: relative;
  border-radius: 8px;
  overflow: hidden;
}
.feedback-dialog-wrap {
  content: '';
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  background-color: rgba(0, 0, 0, 0.45);
  z-index: 1001;
}
.feedback-left-left {
  width: 15%;
  background-color: #fff;
  height: 100%;
  padding: 10px;
  overflow-y: auto;
  padding-top: 22px;
}
.feedback-left {
  width: 20%;
  background-color: rgba(233, 237, 241);
  height: 100%;
  padding: 2px;
}
.feedback-right {
  flex: auto;
  background-color: rgba(243, 243, 243);
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
}
.feedback-right-right {
  width: 15%;
  background-color: #fff;
  height: 100%;
  padding: 10px;
  overflow-y: auto;
  padding-top: 22px;
}
.feedback-left > div {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.left-content {
  overflow-y: auto;
  flex-grow: 1;
}

.feedback-close {
  position: absolute;
  top: 15px;
  /* right: calc(15% + 15px); */
  right: 15px;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  cursor: pointer;
}
.left-header {
  /* border-bottom: 2px solid #fff; */
}
.pro-title {
  height: 60px;
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 600;
  padding: 5px 10px;
  /* border-bottom: 2px solid #fff; */
  width: 100%;
  color: #333;
}

.radish-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 10px;
  /* border-bottom: 2px solid #fff; */
}
.radish-item:hover,
.radish-item-active {
  background-color: #2478b5;
}
.right-header {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: rgba(233, 237, 241);
  /* border: 1px solid rgb(188, 188, 188); */
  padding: 10px;
  padding-right: 40px;
  height: 60px;
}
.detail-info {
  display: flex;
  align-items: center;
  flex-grow: 1;
}
.radish-info {
  display: flex;
  align-items: center;
}
.radish-info-name {
  font-size: 16px;
  color: rgb(51, 102, 154);
  margin-right: 5px;
  cursor: pointer;
  width: 60px;
}

.radish-info-client {
  font-size: 12px;
  color: #999;
}
.right-content {
  width: 100%;
  padding: 20px 10px;
  height: calc(80vh - 160px);
  overflow-y: auto;
  background-color: rgba(249, 249, 249, 1);
}
.feedback-item {
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
}
.feedback-info {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.feedback-clientname {
  font-size: 12px;
  font-weight: 600;
  margin-right: 10px;
  color: #999;
}
.feedback-time {
  font-size: 12px;
  margin-right: 10px;
  color: #999;
}
.feedback-content {
  max-width: 50%;
  background-color: #fff;
  border-radius: 8px;
  margin-left: 60px;
  white-space: pre-line;
  padding: 15px;
  font-size: 14px;
}
.feed-right .feedback-info {
  flex-direction: row-reverse;
}
.feed-right .feedback-content {
  align-self: flex-end;
  margin-right: 60px;
  background-color: rgba(114, 252, 61, 0.69);
}
.right-footer {
  position: relative;
  width: 100%;
  height: 100px;
  box-shadow: 0 0 4px 0px #c1c1c1;
  bottom: 4px;
  right: 1px;
  padding: 10px;
  background-color: #2478b5;
}
.bottom-button {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}

.feedback-left-left-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}
.feedback-left-left-title {
  margin-bottom: 10px;
  font-size: 14px;
  font-weight: 600;
  color: #333;
}
.feedback-left-left-content {
  margin-bottom: 10px;
  font-size: 12px;
  color: #333;
  padding-left: 12px;
}
.feedback-left-left-content b {
  font-weight: normal;
  color: #999;
}
.feedback-left-left-detail {
  font-size: 12px;
  white-space: pre-line;
  line-height: 1.5;
  padding-left: 12px;
}
.feedback-left-left-empty {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.feedback-left-left-empty i {
  color: #eee;
  font-size: 50px;
  margin-bottom: 10px;
}
.feedback-left-left-empty span {
  font-size: 18px;
  color: #eee;
}
.feedback-right-right h3 {
  text-align: center;
  margin-bottom: 10px;
  font-size: 18px;
}
.quick-title {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #a0a0a0;
}
.line {
  width: 30px;
  height: 2px;
  background-color: #a0a0a0;
}
.quick-title span {
  margin: 0 6px;
}
.quick-btn-box {
  padding-top: 8px;
}
.quick-btn {
  background-color: #2478b5;
  padding: 8px 6px;
  text-align: center;
  color: #fff;
  border-radius: 4px;
  margin-bottom: 6px;
  cursor: pointer;
}
.refresh-btn {
  position: absolute;
  top: -26px;
  right: 10px;
  font-size: 20px;
  color: #2478b5;
  cursor: pointer;
}
</style>
